import React, {useEffect} from "react";
import Router from "./router";
import i18next from "i18next";
import lang_en from "./locales/en.json"
import lang_fa from "./locales/fa.json"
import {I18nextProvider, useTranslation} from "react-i18next";
// import detector from "i18next-browser-languagedetector";
import {useLocation} from "react-router";

const App = ()=>{

  const localSavedLang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'fa'

  useEffect(()=>{
    i18next
      // .use(detector)
      .init({
      interpolation: { escapeValue: false },
      fallbackLng: "en",
      lng: localSavedLang,                              // language to use
      resources: {
        en: {
          common: lang_en               // 'common' is our custom namespace
        },
        fa: {
          common: lang_fa
        }
      }
    });
  },[])

  const LangDigit = ({children}) => {
    const {t} = useTranslation("common");

    function useQuery() {
      return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();
    const qLng = query.get("lang");

    useEffect(() => {
      if (qLng) {
        i18next.changeLanguage(qLng);
        if (typeof window !== "undefined") window.localStorage.setItem("lang", qLng);
      }
    }, [qLng])

    return (
        <div id="app-wrap" className={`h-100 ${t("lang") !== "fa" && t("lang") !== "af" && t("lang") !== "ar" ? "english-digit" : ""}`}>
          {children}
        </div>
    );
  };
  return (
    <I18nextProvider i18n={i18next}>
      <LangDigit>
        <Router />
      </LangDigit>
    </I18nextProvider>
  );
}

export default App;
